'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var translations = {
  en: {
    'fund-objective-title': 'OBJECTIVE'
  },
  zh: {
    'fund-objective-title': '投資目標'
  }
};

var targetLanguage = void 0;

var assertLanguageIsSet = function assertLanguageIsSet() {
  if (!targetLanguage) {
    throw new Error('must set a language on the translation service before it can be used');
  }
};

var TranslationService = {
  get: function get(key) {
    assertLanguageIsSet();

    return translations[targetLanguage][key];
  },

  setTargetLanguage: function setTargetLanguage(language) {
    targetLanguage = language;
  }
};

exports.default = TranslationService;
var get = TranslationService.get,
    setTargetLanguage = TranslationService.setTargetLanguage;
exports.get = get;
exports.setTargetLanguage = setTargetLanguage;